


























import Vue from 'vue';
import { LOAD_STATE } from '@/store/shared';
import * as mutations from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import EventTimeline from '@/components/SubscriptionAnalytics/EventTimeline.vue';
import EventOverview from '@/components/SubscriptionAnalytics/EventOverview.vue';
import HealthOverview from '@/components/SubscriptionAnalytics/HealthOverview.vue';
import HealthWatchlist from '@/components/SubscriptionAnalytics/HealthWatchlist.vue';

export default Vue.extend({
  name: 'EventDashboard',
  components: {
    HealthWatchlist,
    HealthOverview,
    EventOverview,
    EventTimeline,
  },
  data() {
    return {
      LOAD_STATE,
    };
  },
  async created() {},
  computed: {
    ...mapGetters(['confidential']),
  },
  methods: {
    setConfidential(confidential: boolean) {
      this.$store.commit(mutations.SET_CONFIDENTIAL, confidential);
    },
  },
});
